import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, unref as _unref, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, withModifiers as _withModifiers, createTextVNode as _createTextVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "bg-success-400 text-black dark:no-change"
}
const _hoisted_2 = {
  key: 1,
  class: "text-white bg-black"
}
const _hoisted_3 = ["hidden"]
const _hoisted_4 = { class: "card !bg-light pt-gr-6 mx-gr-6" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("p", null, "To access your library and continue listening, please verify your email address.", -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("p", { class: "mt-gr-3 text-sm" }, "After verifying email, please restart app.", -1)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("button", { class: "mt-gr-6 btn btn-primary flex w-full" }, "Resend Verification Email", -1)
const _hoisted_8 = [
  _hoisted_7
]
const _hoisted_9 = { class: "mt-gr-7 flex justify-between items-center" }

import AppMenu from '@/components/AppMenu.vue';
import AudioPlayerControlBar from '@/components/AudioPlayerControlBar';
import { IonApp, IonIcon, IonRouterOutlet, IonSplitPane, isPlatform } from '@ionic/vue';
import { onMounted, ref } from 'vue';
import { useAuthStore } from '@/stores/useAuthStore';
import { SplashScreen } from '@capacitor/splash-screen';
import { peopleOutline } from 'ionicons/icons';
import { Browser } from '@capacitor/browser';
import { networkConnected } from '@/composables/useNetwork';


export default /*#__PURE__*/_defineComponent({
  __name: 'App',
  setup(__props) {

if (isPlatform('capacitor')) {
  onMounted(() => {
    SplashScreen.hide();

    let menu = document.querySelector('ion-menu')!

    let touchstartX = 0
    let touchendX = 0

    function checkDirection() {
      if (touchendX < touchstartX) {
        let evt = new Event('closeMenuGesture')
        window.dispatchEvent(evt)
      }
    }

    menu.addEventListener('touchstart', e => {
      touchstartX = e.changedTouches[0].screenX
    })

    menu.addEventListener('touchend', e => {
      touchendX = e.changedTouches[0].screenX
      checkDirection()
    })
  })
}

onMounted(() => {
  document.body.classList.remove('pre-init');
});


let authStore = useAuthStore()
let hidePaywall = ref(true)

setInterval(() => {
  if (authStore.user) {
    if (!authStore.user['email_verified_at']) {
      let createdDate = (new Date() - new Date(authStore.user['created_at'])) / 1000
      if (createdDate > 60 * 60 * 24) {
        hidePaywall.value = false
      }
    }
  }
}, 1000)

async function logout() {
  await authStore.logout()
}

const accountLink = process.env.VUE_APP_ACCOUNT
const supportLink = process.env.VUE_APP_SUPPORT
const openWebView = async (url) => {
  await Browser.open({ url });
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_unref(IonApp), null, {
      default: _withCtx(() => [
        _createVNode(_unref(IonSplitPane), { "content-id": "main-content" }, {
          default: _withCtx(() => [
            _createVNode(AppMenu, { "content-id": "main-content" }),
            _createVNode(_unref(IonRouterOutlet), { id: "main-content" })
          ]),
          _: 1
        }),
        _createVNode(_unref(AudioPlayerControlBar))
      ]),
      _: 1
    }),
    _createElementVNode("div", {
      class: _normalizeClass([_unref(networkConnected) ? 'delay-1000 translate-y-full' : '', "duration-300 fixed z-40 bottom-0 text-center text-xs h-gr-half-7 leading-gr-half-7 inset-x-0 border-b border-white/20"])
    }, [
      (_unref(networkConnected))
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, "You are back online!"))
        : (_openBlock(), _createElementBlock("div", _hoisted_2, "You are offline!"))
    ], 2),
    _createElementVNode("div", {
      class: "fixed inset-0 flex bg-primary-darkest/90 dark:bg-neutral-100/90 items-center justify-center z-[100] backdrop-blur",
      hidden: _unref(hidePaywall)
    }, [
      _createElementVNode("div", _hoisted_4, [
        _hoisted_5,
        _hoisted_6,
        _createElementVNode("form", {
          onSubmit: _cache[0] || (_cache[0] = _withModifiers(
//@ts-ignore
(...args) => (_unref(authStore).resendVerificationEmail && _unref(authStore).resendVerificationEmail(...args)), ["prevent"]))
        }, _hoisted_8, 32),
        _createElementVNode("div", _hoisted_9, [
          _createElementVNode("button", {
            onClick: logout,
            class: "btn btn-yellow"
          }, "Logout"),
          _createElementVNode("button", {
            onClick: _cache[1] || (_cache[1] = ($event: any) => (openWebView(_unref(supportLink)))),
            class: "link"
          }, [
            _createTextVNode(" Contact Support "),
            _createVNode(_unref(IonIcon), {
              src: _ctx.$icon('arrow-up-right-from-square'),
              class: "fa-xs fa-fw -translate-y-gr-1"
            }, null, 8, ["src"])
          ])
        ])
      ])
    ], 8, _hoisted_3)
  ], 64))
}
}

})